import React, { Component } from 'react';
import { connect } from 'react-redux'
import T from 'i18n-react';
import { PersonPin, KeyboardArrowRight, Explore } from '@mui/icons-material'
import { replace, push } from 'connected-react-router'
import ClientActions from '../../store/clientRedux'
import './clients.scss';
import Navigation from '../common/navigation'
import Loader from '../common/loader'
import { withRouter } from 'react-router-dom';
import Section from '../layout/Section';
import { RouteConstants } from '../../router/services/RouteConstants';

class Clients extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lang: this.props.lang,
            client: this.props.client,
            loadingClients: this.props.loadingClients
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.state.client.loadingClients !== newProps.loadingClients) {
            this.setState({ loadingClients: newProps.loadingClients });
        }

        let newQuery = newProps.match.params.query;
        if (newQuery !== this.props.match.params.query) {
            this.setClient(newProps)
        }

        if (this.state.client !== newProps.client) {
            if (newProps.client.clients !== null) {
                if (newProps.client.clients.length > 1) {
                    var presaleClients = false
                    for (var i = 0; i < newProps.client.clients.length; i++) {
                        if (newProps.client.clients[i].userName === '') {
                            presaleClients = true
                            break
                        }
                    }
                    if (presaleClients === true) {
                        this.multiplePresaleClientsFound(newProps.client.clients[0])
                    }
                }
                if (newProps.client.clients.length === 1) {
                    this.exactClientFound(newProps.client.clients[0])
                }
            }
            this.setState({ client: newProps.client })
        }

        if (this.state.lang !== newProps.lang) {
            this.setState({ lang: newProps.lang })
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if (window.location.pathname !== RouteConstants.CLIENTS_SEARCH)
            this.setClient(this.props)
    }

    setClient(props) {
        props.searchClients(props.match.params.query)
    }

    handleClientClick(id) {
        var clientId = id.currentTarget ? id.currentTarget.id : id
        this.props.pushNavigation('/clients/' + clientId)
    }

    exactClientFound(foundClient) {
        var clientId = foundClient.id.currentTarget ? foundClient.id.currentTarget.id : foundClient.id
        if (foundClient.firstName === '') {
            this.props.replaceNavigation('/clients/' + foundClient.email)
        }
        else {
            this.props.replaceNavigation('/clients/' + clientId)
        }

    }

    multiplePresaleClientsFound(firstFoundClient) {
        this.props.replaceNavigation('/clients/' + firstFoundClient.email)
    }

    render() {
        if (this.props.loadingClients === true || !this.props.client) {
            return <Loader />
        }

        // Determine which field to be bold based on search criteria type. 
        var clientCellEmailStyles = ['clientsCellEmail']
        var clientCellUserNameStyles = ['clientsCellUserName']
        var clientCellFirstNameStyles = ['clientsCellFirstName']
        var clientCellPhoneStyles = ['clientsCellPhone']
        if (this.state.client.searchCriteriaType.toUpperCase() === 'email'.toUpperCase())
            clientCellEmailStyles.push('clientCellBold')
        if (this.state.client.searchCriteriaType.toUpperCase() === 'userName'.toUpperCase())
            clientCellUserNameStyles.push('clientCellBold')
        if (this.state.client.searchCriteriaType.toUpperCase() === 'firstNameLastName'.toUpperCase())
            clientCellFirstNameStyles.push('clientCellBold')
        if (this.state.client.searchCriteriaType.toUpperCase() === 'phoneNumber'.toUpperCase())
            clientCellPhoneStyles.push('clientCellBold')

        // Loop through returned clients to display
        var content = []
        if (this.state.client.clients !== null) {
            for (var i = 0; i < this.state.client.clients.length; ++i) {

                // Only show the first 10 results. 
                if (i === 10)
                    break;

                var phone = (this.state.client.clients[i].phone === null || this.state.client.clients[i].phone === '') ? '-' : (this.state.client.clients[i].phone.slice(0, 3) + '-' + this.state.client.clients[i].phone.slice(3, 6) + '-' + this.state.client.clients[i].phone.slice(6))
                var firstName = (this.state.client.clients[i].firstName === null || this.state.client.clients[i].firstName === '') ? '-' : this.state.client.clients[i].firstName
                var userName = (this.state.client.clients[i].userName === null || this.state.client.clients[i].userName === '') ? '-' : this.state.client.clients[i].userName
                var province = (this.state.client.clients[i].province === null || this.state.client.clients[i].province === '') ? '-' : this.state.client.clients[i].province

                content.push(<div className="clientsRow" key={this.state.client.clients[i].id} id={this.state.client.clients[i].id} onClick={(id) => this.handleClientClick(id)} >
                    <div className="clientsCellId" hidden={true} >{this.state.client.clients[i].id}</div>
                    <div className={clientCellEmailStyles.join(' ')}>{this.state.client.clients[i].email}</div>
                    <div className={clientCellUserNameStyles.join(' ')}>{userName}</div>
                    <div className={clientCellFirstNameStyles.join(' ')}>{firstName}</div>
                    <div className={clientCellPhoneStyles.join(' ')}>{phone}</div>
                    <div className="clientsCellProvince">{province}</div>
                    <div className="clientsCellLink"><KeyboardArrowRight style={{ color: '#3F3F3F', paddingBottom: '3px' }} /></div>
                </div>)
            }
        }

        return (
            <div className='content-grid'>
                <Section sectionId='client-search-results' className='white'>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <div></div>
                        <div className="clientsTitle">
                            <Navigation /><br />
                            {(() => {
                                switch (this.state.client.resultsCount) {
                                    case null: return (<div></div>);
                                    default: return (<div><div style={{ paddingBottom: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }} >
                                        <div style={{ paddingTop: '7px', marginLeft: '-13px' }} >&nbsp;&nbsp;&nbsp;<PersonPin style={{ color: '#468522' }} /></div><div> <h1 className="clientsTitleHeader" >{T.translate('ClientLookup.Labels.ClientLookupResults')} {this.state.client.searchCriteria}</h1></div>
                                    </div>
                                        <div style={{ paddingLeft: '5px', paddingBottom: '10px' }} >
                                            <p className="clientsResults" >{this.state.client.resultsCount > 10 ? '10' : this.state.client.resultsCount} {T.translate('ClientLookup.Labels.ResultsFound')}</p>
                                        </div></div>);
                                }
                            })()}

                            <div>
                                {(() => {
                                    switch (this.state.client.resultsCount) { //Added null case for VAI-861 as a temporary fix for not having access to view Return data by Return Id
                                        case 0: case null: return (<div className="noClientsBox" >
                                            <div></div>
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }} >
                                                <div style={{ paddingTop: '30px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} ><div></div><div><Explore style={{ color: '#777777', height: '60px', width: '60px' }} /></div><div></div></div>
                                                <div style={{ font: 'Noto Sans', fontSize: '18px' }} ><p>{T.translate('ClientLookup.NotFound.CouldntFind')}<b>{this.state.client.searchCriteria}</b></p></div>
                                                <div style={{ font: 'Noto Sans', fontSize: '13px', paddingTop: '20px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} ><div></div><div><p>{T.translate('ClientLookup.NotFound.TrySearchingAgain')}</p></div><div></div></div>
                                                <div style={{ font: 'Noto Sans', fontSize: '13px', paddingTop: '20px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} ><div></div><div><ul style={{ listStyleType: 'disc' }} >
                                                    <li>{T.translate('ClientLookup.NotFound.PhoneNumber')}</li>
                                                    <li>{T.translate('ClientLookup.NotFound.AlternativeEmail')}</li>
                                                    <li>{T.translate('ClientLookup.NotFound.Username')}</li>
                                                    <li>{T.translate('ClientLookup.NotFound.OrderNumber')}</li></ul></div>
                                                    <div></div>
                                                </div>
                                            </div>
                                            <div></div>
                                        </div>);
                                        default: return (<div className="clientsTable">
                                            <div className="clientsHeader">
                                                <div className="clientsCellId" align="left" hidden={true} >Customer ID</div>
                                                <div className={clientCellEmailStyles.join(' ')} align="left">{T.translate('ClientLookup.Labels.Email')}</div>
                                                <div className={clientCellUserNameStyles.join(' ')} align="left">{T.translate('ClientLookup.Labels.Username')}</div>
                                                <div className={clientCellFirstNameStyles.join(' ')} align="left">{T.translate('ClientLookup.Labels.Firstname')}</div>
                                                <div className={clientCellPhoneStyles.join(' ')} align="left">{T.translate('ClientLookup.Labels.Phone')}</div>
                                                <div className="clientsCellProvince" align="left">{T.translate('ClientLookup.Labels.Province')}</div>
                                                <div className="clientsCellLink" style={{ backgroundColor: '#FFFFFF', height: '37px' }} align="left">&nbsp;</div>
                                            </div>
                                            {content}
                                        </div>);
                                    }
                                })()}
                            </div>
                        </div>
                        <div></div>
                    </div>
                    {
                        this.props.client.fuzzyClients && this.props.client.fuzzyClients.length > 0 &&
                        <div className="fuzzy-results-container">
                            <div className="clientsTitle">
                                <h1 className="clientsTitleHeader">{T.translate('ClientLookup.Labels.DidYouMean')}</h1>
                                <div className="clientsTable">
                                    <div className="clientsHeader">
                                        <div className="clientsCellId" hidden={true} >Customer ID</div>
                                        <div className="clientsCellEmail" >{T.translate('ClientLookup.Labels.Email')}</div>
                                        <div className="clientsCellUserName">{T.translate('ClientLookup.Labels.Username')}</div>
                                        <div className="clientsCellFirstName">{T.translate('ClientLookup.Labels.Firstname')}</div>
                                        <div className="clientsCellPhone">{T.translate('ClientLookup.Labels.Phone')}</div>
                                        <div className="clientsCellProvince">{T.translate('ClientLookup.Labels.Province')}</div>
                                        <div className="clientsCellLink">&nbsp;</div>
                                    </div>
                                    {
                                        this.props.client.fuzzyClients.map(c => {
                                            const phone = (c.phone === null) ? '-' : (c.phone.slice(0, 3) + '-' + c.phone.slice(3, 6) + '-' + c.phone.slice(6))
                                            const firstName = (c.firstName === null) ? '-' : c.firstName
                                            const userName = (c.userName === null) ? '-' : c.userName
                                            return (
                                                <div className="clientsRow" key={c.id} id={c.id} onClick={(id) => this.handleClientClick(id)}>
                                                    <div className="clientsCellId" hidden={true}>{c.id}</div>
                                                    <div className="clientsCellEmail">{c.email}</div>
                                                    <div className="clientsCellUserName">{userName}</div>
                                                    <div className="clientsCellFirstName">{firstName}</div>
                                                    <div className="clientsCellPhone">{phone}</div>
                                                    <div className="clientsCellProvince">{c.province}</div>
                                                    <div className="clientsCellLink"><KeyboardArrowRight /></div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </Section>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        lang: state.layout.lang,
        client: state.client,
        loadingClients: state.client.loadingClients
    }
}

const mapDispatchToProps = (dispatch) => ({
    pushNavigation: (path) => dispatch(push(path)),
    replaceNavigation: (path) => dispatch(replace(path)),
    searchClients: (searchCriteria) => dispatch(ClientActions.searchClients(searchCriteria))
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Clients))